import React, { useEffect, useState } from 'react';
import '../../styles/Formulario.css';
import {Formik, Form, Field, ErrorMessage} from 'formik';
//Importacion de imagenes de fichos
import fichoAzul from '../../imgs/fichos/Ficho-azul.png';
import fichoRojo from '../../imgs/fichos/Ficho-rojo.png';
import fichoVerde from '../../imgs/fichos/Ficho-verde.png';
import fichoAmarillo from '../../imgs/fichos/Ficho-amarillo.png';
import PantallaPreviaRegistro from './PantallaPreviaRegistro';

//Componentes
import Advertencia from './Advertencia';
import FormularioInstrucciones from './FormularioInstrucciones';
import LlenarDatosError from './LlenarDatosError';


export default function Formulario(props) {
    const [sesionElegida, setSesionElegida] = useState("");
    const [jugadoresElegidos, setJugadoresElegidos] = useState("");
    const [ llenarDatos, setLlenarDatos ] = useState(false);

    //Estado para controlar la abertura de las instrucciones.
    const [ panelInstrucciones, setPanelInstrucciones ] = useState(false);

    //Estado para manejar la pantalla de advertencia.
    const [ pantallaAdvertencia, setPantallaAdvertencia ] = useState(true);

    //Registros
    const [jugador1, setJugador1] = useState("");
    const [jugador2, setJugador2] = useState("");
    const [jugador3, setJugador3] = useState("");
    const [jugador4, setJugador4] = useState("");

    //Registros para la pantalla previa
    const [jugador1Previa, setJugador1Previa] = useState("");
    const [jugador2Previa, setJugador2Previa] = useState("");
    const [jugador3Previa, setJugador3Previa] = useState("");
    const [jugador4Previa, setJugador4Previa] = useState("");

    //Fase1:al responder a que sesion se vincula desaparece esta seccion y aparecen la seccion dos
    const [fase1, setFase1] = useState("1");
    const [fase2, setFase2] = useState("0");
    const [fase3, setFase3] = useState("0");

    //modificamos la posicion del boton de continuar y jugar para que este en la misma posicion de la interfaz en ambas pantallas.
    const [botones, setBotones] = useState("10vw");
    const [botones2, setBotones2] = useState("25vw");
    const [botones3, setBotones3] = useState("40vw");

    //Creamos estados que manejaran los microformularios de cada jugador.
    const [ microformulario1, setMicroFormulario1 ] = useState("0");
    const [ microformulario2, setMicroFormulario2 ] = useState("0");
    const [ microformulario3, setMicroFormulario3 ] = useState("0");
    const [ microformulario4, setMicroFormulario4 ] = useState("0");

    //Posicion formulario de jugadores
    const [posicionFormularioJugadores, setPosicionFormularioJugadores] = useState("0vw");

    //Estado donde se guardaran los datos y errores de la carga en la base de datos.
    const [ sesionesFetch, setSesionesFetch ] = useState([]);
    const [ errorFetch, setErrorFetch ] = useState([]);

    //Estado para mostrar la pantalla con las modificaciones
    const [ pantallaPreviaRegistroState, setPantallaPreviaRegistroState ] = useState(false);

    //Traemos de los props de tema elegido para las preguntas.
    const { setTemaElegido } = props;

    //Funcion que ejecuta el avance a la pantalla de informacion del formulario.
    const validacionCorrecta = () => {
        setPantallaPreviaRegistroState(true);
        setMicroFormulario1("0");
        setMicroFormulario1("0");
        setMicroFormulario1("0");
        setMicroFormulario1("0");
        setBotones3("10vw");
        setFase3("1");
        setBotones2("15vw");
        setFase2("0");
    }

    //Creamos una funcion que captura cuantos jugadores fueron elegidos y hace renderizar esa cantidad de casillas de registro.
    const establecerJugadores = (numeroJugadores) => {
        const validaEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
        //Ejecutamos la funcion qe pasamos por props para desactivar el estado y la pantalla de registro.
        if(numeroJugadores === 1){
            //Ejecutamos un if que valida si el jugador introdujo un valor o dejo vacio el input, si lo dejo vacio activamos un estado que nos muestra un letrero de advertencia. si el input no esta vacio se ejecuta la siguiente pantalla y genera el orden de los jugadores para la abse de datos.
            if(jugador1.jugador === "" || validaEmail.test(jugador1.email) === false){
                setLlenarDatos(true);
            }else if( jugador1 !== "" && (validaEmail.test(jugador1.email)) === true){
                setJugador2(jugador1);
                setJugador3(jugador1);
                setJugador4(jugador1);
                validacionCorrecta();
            }
        }else if(numeroJugadores === 2){
            if( jugador1.jugador === "" || jugador2.jugador === "" || validaEmail.test(jugador1.email) === false || validaEmail.test(jugador2.email) === false){
                setLlenarDatos(true);
            }else if( jugador1.jugador !== "" && jugador2.jugador !== "" && validaEmail.test(jugador1.email) === true && validaEmail.test(jugador2.email) === true ){
                setJugador2(jugador2);
                setJugador4(jugador2);
                setJugador3(jugador1);
                validacionCorrecta();
            }
        }else if(numeroJugadores === 3){
            if( jugador1.jugador === "" || jugador2.jugador === "" || jugador3.jugador === "" || validaEmail.test(jugador1.email) === false || validaEmail.test(jugador2.email) === false || validaEmail.test(jugador3.email) === false ){
                setLlenarDatos(true);
            }else if( jugador1.jugador !== "" && jugador2.jugador !== "" && jugador3.jugador !== "" && validaEmail.test(jugador1.email) === true && validaEmail.test(jugador2.email) === true && validaEmail.test(jugador3.email) === true){
                setJugador4(jugador2);
                validacionCorrecta();
            }
        }else if(numeroJugadores === 4){
            if( jugador1.jugador === "" || jugador2.jugador === "" || jugador3.jugador === "" || jugador4.jugador === "" || validaEmail.test(jugador1.email) === false || validaEmail.test(jugador2.email) === false || validaEmail.test(jugador3.email) === false || validaEmail.test(jugador4.email === false) ){
                setLlenarDatos(true);
            }else if( jugador1.jugador !== "" && jugador2.jugador !== "" && jugador3.jugador !== "" && jugador4.jugador !== "" && validaEmail.test(jugador1.email) === true && validaEmail.test(jugador2.email) === true && validaEmail.test(jugador3.email) === true && validaEmail.test(jugador4.email) === true ){
                validacionCorrecta();
            }
        }

    }


    //Establecer cuantos miniformularios de jugador se muestran en pantalla segun el numero de jugadores elegidos previamente,
    const microFormulariosMostrar = (numeroJugadores) => {
        if(numeroJugadores === 1){
            setMicroFormulario1("1");
        }else if(numeroJugadores === 2){
            setMicroFormulario1("1");
            setMicroFormulario2("1");
        }else if( numeroJugadores === 3){
            setMicroFormulario1("1");
            setMicroFormulario2("1");
            setMicroFormulario3("1");
        }else if( numeroJugadores === 4){
            setMicroFormulario1("1");
            setMicroFormulario2("1");
            setMicroFormulario3("1");
            setMicroFormulario4("1");
        }
    }


    //Creamos un algoritmo para las imagenes correspondientes que apareceran asignadas para cada jugador,primero creamos 4 estados con arrays vacios, posteriormente creamos los arrays y creamos un if que hara push de cada imagen necesaria en cada microformulario y se setearan los estados con ese array que se mostrara dependiendo la cantidad de jugadores y como se penso la configuracion.
    const [jugador1Fichos,setJugador1Fichos] = useState([]);
    const [jugador2Fichos,setJugador2Fichos] = useState([]);
    const [jugador3Fichos,setJugador3Fichos] = useState([]);
    const [jugador4Fichos,setJugador4Fichos] = useState([]);

    let arrayJugador1 = [];
    let arrayJugador2 = [];
    let arrayJugador3 = [];
    let arrayJugador4 = [];

    const imagenesFichosOrdenadas = (numeroJugadores) => {
        if(numeroJugadores === 1){
            arrayJugador1.push(<img src={fichoAzul} alt="fichoAzul"/>);
            arrayJugador1.push(<img src={fichoRojo} alt="fichoRojo"/>);
            arrayJugador1.push(<img src={fichoVerde} alt="fichoVerde"/>);
            arrayJugador1.push(<img src={fichoAmarillo} alt="fichoAmarillo"/>);

            setJugador1Fichos(arrayJugador1);

        }else if(numeroJugadores === 2){
            arrayJugador1.push(<img src={fichoAzul} alt="fichoAzul"/>);
            arrayJugador1.push(<img src={fichoVerde} alt="fichoVerde"/>);
            arrayJugador2.push(<img src={fichoRojo} alt="fichoRojo"/>);
            arrayJugador2.push(<img src={fichoAmarillo} alt="fichoAmarillo"/>);

            setJugador1Fichos(arrayJugador1);
            setJugador2Fichos(arrayJugador2);
        }else if(numeroJugadores === 3){
            arrayJugador1.push(<img src={fichoAzul} alt="fichoAzul"/>);
            arrayJugador2.push(<img src={fichoVerde} alt="fichoVerde"/>);
            arrayJugador3.push(<img src={fichoRojo} alt="fichoRojo"/>);
            arrayJugador3.push(<img src={fichoAmarillo} alt="fichoAmarillo"/>);

            setJugador1Fichos(arrayJugador1);
            setJugador2Fichos(arrayJugador2);
            setJugador3Fichos(arrayJugador3);
        }else if(numeroJugadores === 4){
            arrayJugador1.push(<img src={fichoAzul} alt="fichoAzul"/>);
            arrayJugador2.push(<img src={fichoRojo} alt="fichoRojo"/>);
            arrayJugador3.push(<img src={fichoVerde} alt="fichoVerde"/>);
            arrayJugador4.push(<img src={fichoAmarillo} alt="fichoAmarillo"/>);

            setJugador1Fichos(arrayJugador1);
            setJugador2Fichos(arrayJugador2);
            setJugador3Fichos(arrayJugador3);
            setJugador4Fichos(arrayJugador4);
        }
    }



    //Fetch para traer los datos de las sesiones creadas en el administrador.
        //Fetch datos datalist
    useEffect(() => {
            fetch('https://backend-escalera-udea.onrender.com/api/sesiones')
            .then(response => response.json())
            .then((data) => {
                setSesionesFetch(data);
            },(error) => {
                setErrorFetch(error)
            }
        )
        },[]);


    //Creamos las opciones del datalist con un for y pusheandolas en un array
    let opcionesDatalist = [];
    for(let i = 0; i < sesionesFetch.length; i++){
        opcionesDatalist.push(<option value={sesionesFetch[i].nombreSesion}/>);
    }

    //Creamos una funcion para subir los datos cuando se acabe la partida.
    const guardarDatosArray = () => {
        props.mostrarLetreroCasillaUno();
        //Encontrar id de la sesion elegida
        let idEncontrado;
        for(let i = 0; i < sesionesFetch.length; i++){
            if(sesionElegida === sesionesFetch[i].nombreSesion){
                idEncontrado = sesionesFetch[i]._id;
            }
        }


        let arrayJugadores = [];

        arrayJugadores.push({
            _id: idEncontrado,
            sesion: sesionElegida,
            nombre: jugador1.jugador,
            email: jugador1.email,
        })

        arrayJugadores.push({
            _id: idEncontrado,
            sesion: sesionElegida,
            nombre: jugador2.jugador,
            email: jugador2.email,
        })

        arrayJugadores.push({
            _id: idEncontrado,
            sesion: sesionElegida,
            nombre: jugador3.jugador,
            email: jugador3.email,
        })

        arrayJugadores.push({
            _id: idEncontrado,
            sesion: sesionElegida,
            nombre: jugador4.jugador,
            email: jugador4.email,
        })



    props.datosJugadores(arrayJugadores);
    props.activarPantallaRegistro(false);
}

    //Funcion que envia los datos de los temporizadores elegidos en la sesion a los temporizadores de la app.
    const procesarDatosTemporizador = (sesion) => {
        for(let i = 0; i < sesionesFetch.length; i++){
            if(sesion === sesionesFetch[i].nombreSesion){
                props.datosTemporizadores(sesionesFetch[i].duracionPreguntas, sesionesFetch[i].duracionPistas);
            }
        }
    }

    const procesarDatosTemaElegido = (sesion) => {
        for(let i = 0; i < sesionesFetch.length; i++){
            if(sesion === sesionesFetch[i].nombreSesion){
                setTemaElegido(sesionesFetch[i].temaPreguntas);
            }
        }
    }

    // useEffect(() => {
    //     setTimeout(() => {
    //         setPantallaAdvertencia(true);
    //     }, 2500);
    // }, [])

    const desactivarInstrucciones = () => {
        setPanelInstrucciones(false);
    }

    const cerrarAlerta = () => {
        setLlenarDatos(false);
    }

    return (
        <div className='formulario__div--container'>
            <div className='formulario__div--degradado-fondo'>
                <div className='formulario__div-container-titulos'>
                    <h2 className='formulario__h2 formulario__h2--gusanitos-escaleras'>GUSANITOS Y ESCALERAS</h2>
                    <h2 className='formulario__h2 formulario__h2--registro'>Registro</h2>
                        {pantallaPreviaRegistroState ? (<PantallaPreviaRegistro jugador1={jugador1Previa} jugador2={jugador2Previa} jugador3={jugador3Previa} jugador4={jugador4Previa} arrayJugador1={jugador1Fichos} arrayJugador2={jugador2Fichos} arrayJugador3={jugador3Fichos} arrayJugador4={jugador4Fichos} sesionElegida={sesionElegida} jugadoresElegidos={jugadoresElegidos}/>):("")}
                </div>
                <Formik
                    initialValues={{
                        elegirSesion: "",
                        cantidadJugadores:"",
                        nombreJugador1:"",
                        emailJugador1:"",
                        nombreJugador2:"",
                        emailJugador2:"",
                        nombreJugador3:"",
                        emailJugador3:"",
                        nombreJugador4:"",
                        emailJugador4:"",
                    }}

                    validate={
                        (valores) => {
                            let errores = {}

                            //Tomando datos del formulario en tiempo real.
                            setJugador1({jugador:valores.nombreJugador1, email:valores.emailJugador1});
                            setJugador2({jugador:valores.nombreJugador2, email:valores.emailJugador2});
                            setJugador3({jugador:valores.nombreJugador3, email:valores.emailJugador3});
                            setJugador4({jugador:valores.nombreJugador4, email:valores.emailJugador4});

                            //Tomando datos del formulario en tiempo real.
                            setJugador1Previa({jugador:valores.nombreJugador1, email:valores.emailJugador1});
                            setJugador2Previa({jugador:valores.nombreJugador2, email:valores.emailJugador2});
                            setJugador3Previa({jugador:valores.nombreJugador3, email:valores.emailJugador3});
                            setJugador4Previa({jugador:valores.nombreJugador4, email:valores.emailJugador4});


                            let comprobacion = false;
                            for( let i = 0; i < sesionesFetch.length; i++){
                                if(valores.elegirSesion === sesionesFetch[i].nombreSesion){
                                    comprobacion = true;
                                }
                            }

                            if(!valores.elegirSesion){
                            errores.elegirSesion = "Ingrese una sesión";
                            }else if(comprobacion === false){
                                errores.elegirSesion = "Introduzca una opcion de la lista";
                            }


                            if(!valores.cantidadJugadores){
                            errores.cantidadJugadores = "Ingrese la cantidad de jugadores";
                            }

                            //Validar los campos de los jugadores.
                            

                            return errores;
                        }
                    }

                    onSubmit={(valores) => {

                        // if(valores.cantidadJugadores === 4){
                        //     if(valores.nombreJugador1 === "" || valores.nombreJugador2 === "" || valores.nombreJugador3 === "" || valores.nombreJugador4 === "") {
                        //         setLlenarDatos(true);
                        //     }
                        // }else{
                        //     console.log("Fallo");
                        // }



                            setJugadoresElegidos(valores.cantidadJugadores);
                            microFormulariosMostrar(valores.cantidadJugadores);
                            imagenesFichosOrdenadas(valores.cantidadJugadores);
                            setSesionElegida(valores.elegirSesion);
                            setFase1("0");
                            setFase2("1");
                            setBotones("15vw");
                            setBotones2("10vw");
                            setPosicionFormularioJugadores("4vw");
                            procesarDatosTemporizador(valores.elegirSesion);
                            procesarDatosTemaElegido(valores.elegirSesion);
                        }}

                >
                {({errors}) => (
                    <Form className='formulario__form--container' >
                        <div className='formulario__div--container-parte1' style={{opacity:fase1}}>
                            <div className='formulario__div--container-elegir-sesion'>
                                {/* Campo para elegir el tema de la sesion*/}
                                <div className='formulario__div--container-elegir-sesion'>
                                    <label>Elegir sesión para jugar</label>
                                </div>
                                <label htmlFor="dataList" >
                                    <Field
                                    type="text"
                                    className="formulario__field formulario__field--elegir-sesion"
                                    list="datos-lista"
                                    name="elegirSesion"
                                    id="elegirSesion"
                                    />
                                </label>
                                <datalist id="datos-lista">
                                    {opcionesDatalist}
                                </datalist>
                                <ErrorMessage name="elegirSesion" component={() => (<div className='formulario__div--error'>{errors.elegirSesion}</div>)} />
                            </div>
                        <div>
                            <div className='formulario__div--container-cantidad-jugadores'>
                                {/* Campo de la cantidad de jugadores */}
                                <div className='formulario__div--container-cantidad-jugadores'>
                                    <label>Elegir cantidad de jugadores 1-4</label>
                                </div>
                                    <Field
                                        type="number"
                                        id="cantidadJugadores"
                                        name="cantidadJugadores"
                                        className="formulario__field formulario__field--numero-jugadores"
                                        min="1"
                                        max="4"
                                        pattern="^[0-9]+"
                                    >
                                    </Field>
                                </div>
                                <ErrorMessage name="cantidadJugadores" component={() => (<div className='formulario__div--error'>{errors.cantidadJugadores}</div>)} />
                            </div>
                        </div>


                        <div className='formulario__div--boton-continuar'>
                            <button className="formulario__button formulario__button--continuar" style={{opacity: fase1, bottom: botones}}>Continuar</button>
                        </div>



                        {/*Jugadores*/}

                        <div className='formulario__div__grilla-jugadores' style={{opacity:fase2, bottom: posicionFormularioJugadores}}>
                            {/* Campo del primer jugador*/}
                            <div className='formulario__div--container-jugador' style={{opacity:microformulario1}}>
                                <div>
                                    <h3 className='formulario__h3'>Jugador 1</h3>
                                    <div className='formulario__div--contenedor-inputs'>
                                        <label className='formulario__label--jugadores'>Nombre completo:</label>
                                        <Field
                                            type="text"
                                            id="nombreJugador1"
                                            name="nombreJugador1"
                                            className="formulario__field formulario__field--jugador1"
                                            placeholder="Nombre completo"
                                        >
                                        </Field>

                                        <ErrorMessage name="nombreJugador1" component={() => (<div className='formulario__div--error'>{errors.nombreJugador1}</div>)} />

                                        <div className=''>
                                            <label className='formulario__label--jugadores'>Email:</label>
                                            <Field
                                                type="email"
                                                id="emailJugador1"
                                                name="emailJugador1"
                                                className="formulario__field formulario__field--email1"
                                                placeholder="email"
                                            >
                                            </Field>
                                        </div>
                                        <ErrorMessage name="emailJugador1" component={() => (<div className='formulario__div--error'>{errors.emailJugador1}</div>)} />
                                    </div>
                                </div>
                                <div className='formulario__div--container-imagen'>
                                    {jugador1Fichos}
                                </div>
                            </div>


                            {/* Campo del segundo jugador*/}
                            <div className='formulario__div--container-jugador' style={{opacity:microformulario2}}>
                                <div>
                                    <h3 className='formulario__h3'>Jugador 2</h3>
                                    <div className='formulario__div--contenedor-inputs'>
                                        <label className='formulario__label--jugadores'>Nombre completo:</label>
                                        <Field
                                            type="text"
                                            id="nombreJugador2"
                                            name="nombreJugador2"
                                            placeholder="Nombre completo"
                                        >
                                        </Field>
                                    
                                        <ErrorMessage name="nombreJugador2" component={() => (<div className='formulario__div--error'>{errors.nombreJugador2}</div>)} />

                                        <div className=''>
                                            <label className='formulario__label--jugadores'>Email:</label>
                                            <Field
                                                type="email"
                                                id="emailJugador2"
                                                name="emailJugador2"
                                                placeholder="email"
                                            >
                                            </Field>
                                        </div>
                                        <ErrorMessage name="emailJugador2" component={() => (<div className='formulario__div--error'>{errors.emailJugador2}</div>)} />
                                    </div>
                                </div>
                                <div className='formulario__div--container-imagen'>
                                    {jugador2Fichos}
                                </div>
                            </div>

                            {/* Campo del tercer jugador*/}
                            <div className='formulario__div--container-jugador' style={{opacity:microformulario3}}>
                                <div>
                                    <h3 className='formulario__h3'>Jugador 3</h3>
                                    <div className='formulario__div--contenedor-inputs'>
                                        <label className='formulario__label--jugadores'>Nombre completo:</label>
                                        <Field
                                            type="text"
                                            id="nombreJugador3"
                                            name="nombreJugador3"
                                            placeholder="Nombre completo"
                                        >
                                        </Field>
                                    
                                        <ErrorMessage name="nombreJugador3" component={() => (<div className='formulario__div--error'>{errors.nombreJugador3}</div>)} />

                                        <div className=''>
                                            <label className='formulario__label--jugadores'>Email:</label>
                                            <Field
                                                type="email"
                                                id="emailJugador3"
                                                name="emailJugador3"
                                                placeholder="email"
                                            >
                                            </Field>
                                        </div>
                                        <ErrorMessage name="emailJugador3" component={() => (<div className='formulario__div--error'>{errors.emailJugador3}</div>)} />
                                    </div>
                                </div>
                                <div className='formulario__div--container-imagen'>
                                    {jugador3Fichos}
                                </div>
                            </div>

                            {/* Campo del cuarto jugador*/}
                            <div className='formulario__div--container-jugador' style={{opacity:microformulario4}}>
                                <div>
                                    <h3 className='formulario__h3'>Jugador 4</h3>
                                    <div className='formulario__div--contenedor-inputs'>
                                        <label className='formulario__label--jugadores'>Nombre completo:</label>
                                        <Field
                                            type="text"
                                            id="nombreJugador4"
                                            name="nombreJugador4"
                                            placeholder="Nombre completo"
                                        >
                                        </Field>
                                    
                                        <ErrorMessage name="nombreJugador4" component={() => (<div className='formulario__div--error'>{errors.nombreJugador4}</div>)} />

                                        <div className=''>
                                            <label className='formulario__label--jugadores'>Email:</label>
                                            <Field
                                                type="email"
                                                id="emailJugador4"
                                                name="emailJugador4"
                                                placeholder="email"
                                            >
                                            </Field>
                                        </div>
                                        <ErrorMessage name="emailJugador4" component={() => (<div className='formulario__div--error'>{errors.emailJugador4}</div>)} />
                                    </div>
                                </div>
                                <div className='formulario__div--container-imagen'>
                                    {jugador4Fichos}
                                </div>
                            </div>
                        </div>
                    </Form>
                )}

                </Formik>
                <button className='formulario__button formulario__div--boton-jugar' onClick={() => establecerJugadores(jugadoresElegidos)} style={{opacity:fase2, bottom: botones2}}>Continuar</button>
                <button className='formulario__button formulario__div--boton-jugar' onClick={() => guardarDatosArray()} style={{opacity:fase3, bottom: botones3}}>Comenzar Partida</button>
                {pantallaAdvertencia ? (<Advertencia setPantallaAdvertencia={setPantallaAdvertencia}/>):("")}
            </div>
            {panelInstrucciones ? (<FormularioInstrucciones desactivarInstrucciones={desactivarInstrucciones}/>):('')}
            <button onClick={() => setPanelInstrucciones(true)} className='formulario__button--instrucciones'></button>
            {llenarDatos ? (<LlenarDatosError cerrarAlerta={cerrarAlerta}/>):("")}
        </div>
    )
}


